import { Box, CircularProgress } from '@frontierag/frontier-ui-library';

import styles from './styles';
import type { ILoadingIcon } from './types';

export default function LoadingIcon({ children, loading }: ILoadingIcon) {
  return (
    <Box component="span" display="flex" position="relative" alignItems="center">
      {children}
      {loading && <CircularProgress size={24} color="primary" sx={styles.loader} />}
    </Box>
  );
}
